export enum FieldStatus {
  unverified = 'UNVERIFIED',
  verified = 'VERIFIED',
  rejected = 'REJECTED',
  pending = 'PENDING',
}

export interface Profile {
  id: string
  name: string
  surname: string
  profilePicture: string
  caretakerServicesStatus: boolean
  personalDataStatus: {
    complete: boolean
    userImageStatus: FieldStatus
  }
  professionalDataStatus: boolean
  bankDataStatus: {
    complete: boolean
    bankAccountRequirements: {
      eventuallyDue: string[]
      errors: string[]
    }
  }
  identityVerificationStatus: {
    complete: boolean
    status: FieldStatus
  }
  active: boolean
  firstTimeComplete: boolean
  isVerified: boolean
}

export interface ProfileModelView {
  id: string
  name: string
  surname: string
  profilePicture: string
  caretakerServicesStatus: boolean
  personalDataStatus: {
    complete: boolean
    userImageStatus: FieldStatus
  }
  professionalDataStatus: boolean
  bankDataStatus: {
    complete: boolean
    eventuallyDue: string[]
  }
  identityVerificationStatus: {
    complete: boolean
    status: FieldStatus
  }
  active: boolean
  firstTimeComplete: boolean
  isVerified: boolean
}

export interface UpdateQualification {
  id: number
  type: string
  specialty: string
  area: string
  qualificationName: string
  qualificationFile: string
  qualificationFileName: string
  membershipNumber: string
  medicalSchool: string
}

export enum DownloadFileType {
  reference = 'reference',
  cv = 'cv',
  qualification = 'qualification',
}

export interface DownloadFile {
  id?: number
  type: DownloadFileType
}

export interface CaretakerServiceLengthInfo {
  caretakerLength: number
  requestId: number
}

export interface CustomerServiceLengthInfo {
  customerLength: number
  requestId: number
}

export enum QualificationSpecialty {
  socialEducation = 'Educación social',
  nursing = 'Enfermería',
  medicine = 'Medicina',
  pedagogy = 'Pedagogía',
  podiatry = 'Podología',
  occupationalTherapy = 'Terapia ocupacional',
  psychology = 'Psicología',
  childhoodEducation = 'Educación Infantil',
  primaryEducation = 'Educación Primaria',
  specialEducation = 'Educación Especial',
  socialJob = 'Trabajo Social',
  sanitaryStudent = 'Estudiante sector sanitario',
  educationStudent = 'Estudiante sector educativo',
  foreignTitle = 'Título extranjero sin homologar',
  dependencyPositionAttendance = 'Atención a personas en situación de dependencia',
  auxiliaryNurse = 'Auxiliar de enfermería',
  sanitaryEmergenciesTechnician = 'Técnico Emergencias Sanitarias',
  socialIntegration = 'Integración Social',
  socialTechnician = 'Técnico Superior en Animación Sociocultural y Turística',
  healthcareDependantPeopleInSocialInstitutions = 'Certificado - Atención Sociosanitaria a Personas Dependientes en Instituciones Sociales',
  healthcareDependantPeopleAtHome = 'Certificado - Atención Sociosanitaria a Personas Dependientes en el domicilio',
  freeTimeMonitor = 'Monitor de Ocio y Tiempo Libre',
  neurologicAffections = 'Afecciones neurológicas',
  physicalAffections = 'Afecciones físicas',
  psychosocial = 'Psicosocial',
  other = 'Otra',
}

export enum QualificationArea {
  sanitary = 'Sanitaria',
  psychosocial = 'Psicosocial',
  educational = 'Educativa',
  cosmeticAndComfort = 'Estética y bienestar',
  other = 'Otra',
}

export enum QualificationType {
  universityEducation = 'Formación universitaria',
  jobTraining = 'FP y Certificados Profesionales',
  course = 'Curso',
}

export interface CaretakerQualification {
  qualificationName: string
  qualificationSpecialty: QualificationSpecialty
  qualificationArea: QualificationArea
  qualificationType: QualificationType
}



// WEBPACK FOOTER //
// ./src/domain/model/caretaker/caretaker.model.ts